<template>
  <main-layout>
    <new-maker-dialog v-model="isNewMakerDialogOpened" @created="makerCreated" />
    <new-users-dialog v-model="isNewUsersDialogOpened" :maker="newMaker" @ended="usersCreated" />
    <new-priorities-dialog v-model="isNewPrioritiesDialogOpened" :maker="newMaker" @ended="prioritiesCreated" />
    <new-domains-dialog v-model="isNewDomainsDialogOpened" :maker="newMaker" @ended="domainsCreated" />
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Prestataires</span>
        <v-spacer></v-spacer>
        <!-- <v-progress-circular
          indeterminate
          color= "primary"
          size="25"
          v-if="isFetchingMakers"
        /> -->
        <v-btn dark color="primary" elevation="0" @click="isNewMakerDialogOpened = true">
          <v-icon left>add</v-icon>
          Nouveau prestataire
        </v-btn>
      </v-row>
      <v-col class="py-2 search-bar border-component">
        <v-text-field
          v-model="searchString"
          placeholder="Rechercher un prestataire..."
          prepend-icon="search"
          hide-details
          dense
          clearable
          class="input-no-b-line"
        ></v-text-field>
      </v-col>
      <v-col class="pa-0 mt-4">
        <n-card v-if="isFetchingMakers">
          <v-progress-linear
            indeterminate
            color= "primary"
            height="6"
            class="absolute-progress"
          />
        </n-card>
        <template v-else>
          <div class="pt-1 pb-5 pr-1">
            <v-row no-gutters justify="center" align="center">
              <h3 class="pl-2">{{ makers.length }} {{ `prestataire` | pluralize(makers.length) }} {{ `trouvé` | pluralize(makers.length) }}</h3>
              <v-spacer />
              <div v-if="makers.length">
                <v-row no-gutters justify="center" align="center">
                  <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <div class="ml-2 primary--text font-weight-bold">
                    {{ currentPage + 1 }} / {{ nbPages }}
                  </div>
                  <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-row>
              </div>
            </v-row>
          </div>
          <n-card v-if="!makers.length">
            <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;">
              Aucun prestataire
            </v-row>
          </n-card>
          <template v-else>
            <v-list class="pa-0 border-component" style="position: relative; overflow: hidden; min-height: 7px;">
              <template v-for="(maker, index) in filteredMakersPaginated">
                <v-list-item
                  :key="`user-${index}`"
                  :to="`/settings/makers/${maker.id}`"
                >
                  <v-list-item-avatar>
                    <v-icon size="medium">handyman</v-icon>
                  </v-list-item-avatar>

                  <v-row no-gutters>
                    <v-col align="left">
                      <v-list-item-content>
                        <v-list-item-title>{{ maker.name }}</v-list-item-title>
                        <v-list-item-content class="pb-0 pt-1" v-if="maker.clientTags.length">
                          <div>
                            <tag-chip v-for="tag in maker.clientTags" :key="`tag-${tag.id}`" :tag="tag" />
                          </div>
                        </v-list-item-content>
                      </v-list-item-content>
                    </v-col>
                    <!-- <v-tooltip left v-if="makerUrl(maker) === null">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mt-1 ml-3">lock</v-icon>
                      </template>
                      <span>Ce prestataire gère lui-même ses informations</span>
                    </v-tooltip> -->
                  </v-row>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < makers.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
            <div class="pa-4">
              <v-row no-gutters justify="center" align="center">
                <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
                <div class="ml-2 primary--text font-weight-bold">
                  {{ currentPage + 1 }} / {{ nbPages }}
                </div>
                <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-row>
            </div>
          </template>
        </template>
      </v-col>
    </div>
  </main-layout>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import MainLayout from '@/views/settings/MainLayout.vue';
import NewMakerDialog from '@/components/Settings/Makers/NewMakerDialog.vue';
import NewUsersDialog from '@/components/Settings/Makers/NewUsersDialog.vue';
import NewPrioritiesDialog from '@/components/Settings/Makers/NewPrioritiesDialog.vue';
import NewDomainsDialog from '@/components/Settings/Makers/NewDomainsDialog.vue';

const PAGE_SIZE = 25;

export default {
  name: `SettingsClientsList`,
  data: () => ({
    isFetchingMakers: false,
    isNewUserDialogOpened: false,
    isUserDialogOpened: false,
    isNewMakerDialogOpened: false,
    isNewUsersDialogOpened: false,
    isNewPrioritiesDialogOpened: false,
    isNewDomainsDialogOpened: false,
    newMaker: null,
    currentPage: 0,
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/settingsMakers`, [
      `isKeepingPreviousState`,
    ]),
    // ...mapState(`ui/mainLayout`, [`isDemoApp`]),
    // canAddClient() {
    //   return [`aba`].indexOf(this.company.slug) === -1 || this.isDemoApp;
    // },
    searchString: {
      get() {
        return this.storeSearchString;
      },
      set(searchString) {
        this.setSearchString(searchString);
      },
    },
    ...mapState(`ui/settingsMakers`, {
      storeSearchString: `searchString`,
    }),
    storeMakers() {
      return _
        .orderBy(this.$store.getters[`ui/settingsMakers/list`], `name`)
        .filter(maker => maker.id !== this.company.id)
        .map(maker => ({
          ...maker,
          clientTags: _.sortBy(maker.clientTags || [], tag => _.toLower(tag.label)),
          searchString: _.lowerCase(maker.name),
        }));
    },
    makers() {
      let makers = this.storeMakers;
      if (this.searchString) {
        const searchString = _.lowerCase(this.searchString);
        makers = _.filter(makers, client =>
          client.searchString.indexOf(searchString) !== -1
        );
      }
      return makers;
    },
    filteredMakersPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.makers.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    nbPages() {
      return Math.ceil(this.makers.length / PAGE_SIZE);
    },
  },
  methods: {
    setSearchString(searchString) {
      this.$store.commit(`ui/settingsMakers/SET_SEARCH_STRING`, searchString);
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageSitIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageSitIndex < this.makers.length) {
        this.currentPage += 1;
      }
    },
    makerUrl(maker) {
      return maker.slug === `` ? `/settings/makers/${maker.id}` : null;
    },
    makerCreated(maker) {
      // this.$store.dispatch(`showSnackbar`, {
      //   color: `success`,
      //   message: `Prestataire créé avec succès`,
      // });
      // this.$router.push(this.makerUrl(maker));
      this.newMaker = maker;
      this.isNewUsersDialogOpened = true;
    },
    usersCreated() {
      this.isNewUsersDialogOpened = false;
      this.isNewPrioritiesDialogOpened = true;
    },
    prioritiesCreated() {
      this.isNewPrioritiesDialogOpened = false;
      this.isNewDomainsDialogOpened = true;
    },
    domainsCreated() {
      this.isNewDomainsDialogOpened = false;
      this.newMaker = null;
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Création du prestaire terminée`,
      });
    },
  },
  async beforeMount() {
    this.isFetchingMakers = true;
    this.currentPage = 0;
    if (!this.isKeepingPreviousState) {
      this.setSearchString(``);
      this.$store.commit(`ui/settingsMakers/SET_KEEPING_PREVIOUS_STATE`, false);
    } else if (!this.storeMakers.length) {
      this.$store.dispatch(`ui/settingsMakers/setList`, []);
    }
    await this.$store.dispatch(`ui/settingsMakers/fetchList`);
    this.isFetchingMakers = false;
  },
  watch: {
    searchString() {
      this.currentPage = 0;
    },
    searchTags() {
      this.currentPage = 0;
    },
  },
  components: {
    MainLayout,
    NewMakerDialog,
    NewUsersDialog,
    NewPrioritiesDialog,
    NewDomainsDialog,
  },
};
</script>

<style lang="scss">
  .search-bar {
    background: white;
  }
  .border-component {
    border: 1px solid #DDDDDD !important;
    border-radius: 6px !important;
  }
  .v-input__slot::before {
    display: none
  }
</style>
